export default __webpack_public_path__ + "static/media/tlb844s.2131a487.png";